import { DefaultApi } from './api'
import { ConsumptionList, ExtrasConsumptionList } from './interfaces'

export const getConsumption = (page = 1) =>
  DefaultApi.request<ConsumptionList>(`company/combo/products/report?page=${page}`, {
    method: 'GET',
  })

export const getExtrasConsumption = () =>
  DefaultApi.request<ExtrasConsumptionList>('/combo/report/extras/current-month', { method: 'GET' }).then((data) => {
    return {
      ...data,
      data: {
        ...data?.data,
        products: data?.data?.products.map((product) => ({
          ...product,
          price: product?.price?.toFixed(2),
          total: product?.total?.toFixed(2),
        })),
        total_price: data?.data?.total_price?.toFixed(2),
        invoice: data?.data?.invoice
          ? {
              ...data?.data?.invoice,
              amount: data?.data?.invoice?.amount?.toFixed(2),
            }
          : null,
      },
    }
  })
